import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';
import CatalogItemReferences from './CatalogItemReferences';
import app from '../app';

export default Backbone.Model.extend({

    initialize: function () {},

    urlRoot: function () {
        return `${app.config.contextPath}/catalog_items`;
    },

    url: function () {
        return `${this.urlRoot()}/${this.get('dataSourceId')}/${this.id}`;
    },

    set: function (key, value, options) {
        // Normalize the key-value into an object
        let attrs;

        if (_.isObject(key) || key === null) {
            attrs = key;
            options = value;
        } else {
            attrs = {};
            attrs[key] = value;
        }

        // Go over all the set attributes and make your changes
        for (const attr in attrs) {
            if (attr === 'references' && !(attrs[attr] instanceof Backbone.Model)) {
                attrs[attr] = new CatalogItemReferences(attrs[attr]);
            }
        }

        return Backbone.Model.prototype.set.call(this, attrs, options);
    },

    validateQuantity: function (quantity) {
        quantity = parseFloat(quantity);

        if (isNaN(quantity)) {
            return false;
        }

        const quantityMin = parseFloat(this.get('quantityMin'));
        const quantityInterval = parseFloat(this.get('quantityInterval'));

        if (!isNaN(quantityMin)) {
            if (quantityMin > quantity) {
                return false;
            }

            if (!isNaN(quantityInterval)) {
                if ((quantity - quantityMin) % quantityInterval !== 0) {
                    return false;
                }
            }
        }

        return true;
    },

    getPrice: function (quantity, discountRate, selectReferenceItemId, selectServiceReferenceItemId, optionalSelectProductIds, callback) {
        const data = {
            quantity: quantity,
            _csrf: $('meta[name="_csrf_token"]').attr('content')
        };

        if (!_.isUndefined(discountRate) && !_.isNull(discountRate)) {
            data.discountRate = discountRate;
        }

        if (!_.isUndefined(selectReferenceItemId) && !_.isNull(selectReferenceItemId)) {
            data.selectProductId = selectReferenceItemId;
        }

        if (!_.isUndefined(selectServiceReferenceItemId) && !_.isNull(selectServiceReferenceItemId)) {
            data.selectServiceProductId = selectServiceReferenceItemId;
        }

        if (!_.isUndefined(optionalSelectProductIds) && !_.isNull(optionalSelectProductIds)) {
            data.optionalSelectProductIds = optionalSelectProductIds;
        }

        $.ajax({
            url: `${this.url()}/price`,
            type: 'GET',

            data: data,

            accepts: { json: 'application/json' },

            complete: function (jqXHR, textStatus) {
                if (typeof callback !== 'undefined') {
                    return callback(jqXHR, textStatus);
                }
                return undefined;
            }
        });
    },

    getReferencePrices: function (quantity, discountRate, selectReferenceItemId, selectServiceReferenceItemId, optionalSelectProductIds, callback) {
        const data = {
            quantity: quantity,
            _csrf: $('meta[name="_csrf_token"]').attr('content')
        };

        if (!_.isUndefined(discountRate) && !_.isNull(discountRate)) {
            data.discountRate = discountRate;
        }

        if (!_.isUndefined(selectReferenceItemId) && !_.isNull(selectReferenceItemId)) {
            data.selectProductId = selectReferenceItemId;
        }

        if (!_.isUndefined(selectServiceReferenceItemId) && !_.isNull(selectServiceReferenceItemId)) {
            data.selectServiceProductId = selectServiceReferenceItemId;
        }

        if (!_.isUndefined(optionalSelectProductIds) && !_.isNull(optionalSelectProductIds)) {
            data.optionalSelectProductIds = optionalSelectProductIds;
        }

        $.ajax({
            url: `${this.url()}/price/references`,
            type: 'GET',

            data: data,

            accepts: { json: 'application/json' },

            complete: function (jqXHR, textStatus) {
                if (typeof callback !== 'undefined') {
                    return callback(jqXHR, textStatus);
                }
                return undefined;
            }
        });
    },

    getImageUrl: function (size, index) {
        // by default, use first image
        if (_.isUndefined(index)) {
            index = this.getMainImageIndex();
        }

        let imageUrl = null;

        // check if image with specified index exists
        if (!_.isUndefined(this.get('images')) && !_.isUndefined(this.get('images')[index])) {
            const image = this.get('images')[index];
            const supplierCatalog = this.get('supplierCatalog');

            // image downloader active
            if (app.config.useLocalImages) {
                imageUrl = `${app.config.contextPath}/media/${supplierCatalog.supplier.portalCustomerId}/${supplierCatalog.supplier.id}/${supplierCatalog.id}/${image.id}-${size}x${size}.jpg`;
            }

            if (image.source.match(/^http/)) {
                imageUrl = image.source;
            } else {
                imageUrl = null;
                if (supplierCatalog.mimeRoot !== null && supplierCatalog.mimeRoot !== '' && supplierCatalog.mimeRoot !== '.') {
                    const extSupplierId = (supplierCatalog.supplier.externalSupplierId === null) ? '' : supplierCatalog.supplier.externalSupplierId;
                    const supplierCatalogId = (supplierCatalog.catalogId === null) ? '' : supplierCatalog.catalogId;
                    imageUrl = `${window.POne.config.mediaServerUrl}/product-images/${extSupplierId}/${supplierCatalogId}/${image.source}`;
                }
            }
        }

        if (_.isNull(imageUrl)) {
            imageUrl = `${app.config.contextPath}/resources/images/no-image-${size}.png`;
        }

        return imageUrl;
    },

    getMainImageIndex: function () {
        let index = 0;
        const thumbImages = this.get('thumbImages');
        if (!_.isUndefined(thumbImages)) {
            for (let idx = 0; idx < thumbImages.length; idx += 1) {
                if (thumbImages[idx].purpose === 'main') {
                    index = idx;
                    break;
                }
            }
        }

        return index;
    },

    getReference: function (catalogItem) {
        const references = this.get('references').filter((reference) => (
                reference.get('childCatalogItem').id === catalogItem.id &&
                reference.get('childCatalogItem').get('dataSourceId') === catalogItem.dataSourceId
            ));

        return (references.length === 0) ? null : references[0];
    }
});



// WEBPACK FOOTER //
// ./model/CatalogItem.js